import { render } from "./ServiceSpanishToEnglish.vue?vue&type=template&id=404fb9f9"
import script from "./ServiceSpanishToEnglish.vue?vue&type=script&lang=js"
export * from "./ServiceSpanishToEnglish.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__